<div class="vf-ask-ai-overlay" *ngIf="open" (mousedown)="onBackdropMouseDown($event)">
    <div class="vf-ask-ai-backdrop"></div>
    <div class="vf-ask-ai-dialog" (mousedown)="$event.stopPropagation()">

        <!-- Header -->
        <div class="vf-ask-ai-header">
            <div class="vf-ask-ai-header-icon">
                <lucide-icon name="sparkles" [size]="16" [strokeWidth]="2"></lucide-icon>
            </div>
            <div class="vf-ask-ai-header-text">
                <div class="vf-ask-ai-header-title">Ask AI to write something</div>
                <div class="vf-ask-ai-header-hint">{{ hintText }}</div>
            </div>
            <button type="button" class="vf-ask-ai-close-btn" aria-label="Close" (click)="close()">
                <lucide-icon name="x" [size]="16" [strokeWidth]="2"></lucide-icon>
            </button>
        </div>

        <!-- Body -->
        <div class="vf-ask-ai-body">
            <div class="vf-ask-ai-input-shell">

                <!-- Context toggle row — only shown when notes have content -->
                <div class="vf-ask-ai-context-row" *ngIf="hasNotesContent">
                    <button type="button"
                            class="vf-ask-ai-switch"
                            [class.is-on]="useNotesAsContext"
                            role="switch"
                            [attr.aria-checked]="useNotesAsContext"
                            aria-label="Use my notes as context"
                            (click)="toggleContext()">
                        <span class="vf-ask-ai-switch-thumb"></span>
                    </button>
                    <span class="vf-ask-ai-context-label">Use my notes as context</span>
                    <span class="vf-ask-ai-context-hint">{{ toggleHint }}</span>
                </div>

                <textarea #promptTextarea
                          class="vf-ask-ai-textarea"
                          [(ngModel)]="prompt"
                          [placeholder]="placeholderText"
                          (keydown)="onTextareaKeydown($event)"
                          rows="6"></textarea>
            </div>
        </div>

        <!-- Footer -->
        <div class="vf-ask-ai-footer">
            <div class="vf-ask-ai-footer-actions">
                <button type="button" class="vf-ask-ai-cancel-btn" (click)="close()">Cancel</button>
                <button type="button"
                        class="vf-ask-ai-action-btn"
                        [class.is-disabled]="!canSubmit"
                        [disabled]="!canSubmit"
                        (click)="submit()">
                    <lucide-icon name="sparkles" [size]="14" [strokeWidth]="2"></lucide-icon>
                    <span>{{ actionLabel }}</span>
                </button>
            </div>
        </div>
    </div>
</div>
